import { List, ListItem } from '@material-ui/core'
import React from 'react'
import {
  AddProcedureDocument,
  NewProcedure,
  Procedure,
  ProcedureDocument,
  ProcedureParameter
} from '../../../../api/Argentia/endpoints/procedures'
import {
  AnnexedParameters,
  DocumentTypes,
  ProcedureStates,
  ProcedureTypes
} from '../../../../api/Argentia/enums'
import {
  enumEnumToValueNumber,
  enumKeyToValue,
  enumTranslateOption,
  enumValueToKey
} from '../../../../helpers'
import { generateIconsFromConfiguration } from '../../../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../../../model'
import {
  ProcedureDetailModel,
  ProcedureDocumentModel,
  ProcedureModel
} from './comunicationProcedures.model'
import {
  filterApplicableDocumentsActionsConfiguration,
  getGlobalActionsConfiguration
} from './comunicationProdecures.service'

import { DateTime } from 'luxon'
import moment from 'moment'

export const comunicationsProceduresListItemsMapper = (items: Procedure[]): ProcedureModel[] => {
  return items && items.map(comunicationsProceduresListItemMapper)
}

export const comunicationsProceduresListItemMapper = (item: Procedure): ProcedureModel => {
  if (!item) return {} as ProcedureModel

  const canCancelItem = canCancel(
    enumValueToKey(ProcedureTypes, item.type),
    enumValueToKey(ProcedureStates, item.state)
  )

  const canWithdrawItem = canWithdraw(
    enumValueToKey(ProcedureTypes, item.type),
    enumValueToKey(ProcedureStates, item.state)
  )

  const canReinstatementItem = canReinstatement(
    enumValueToKey(ProcedureTypes, item.type),
    enumValueToKey(ProcedureStates, item.state)
  )
  return {
    ...item,
    type: enumValueToKey(ProcedureTypes, item.type),
    state: enumValueToKey(ProcedureStates, item.state),
    actionsConfiguration: getGlobalActionsConfiguration(),
    canCancel: canCancelItem,
    canCancelBajaGas: canCancelBajaGas(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state)
    ),
    canReconnect: canReconnect(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state)
    ),
    isPendingInformation: isPendingInformation(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state)
    ),
    isPendingInformationClaim: isPendingInformationClaim(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state)
    ),
    canChangeState: canChangeState(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state),
      item.parameters
    ),
    isPendingInformationReinstatement: isPendingInformationReinstatement(
      enumValueToKey(ProcedureTypes, item.type),
      enumValueToKey(ProcedureStates, item.state)
    ),
    canClosed: enumValueToKey(ProcedureStates, item.state) === ProcedureStates.Iniciado,
    canWithdraw: canWithdrawItem,
    canCancelOrWithdraw: canCancelItem || canWithdrawItem || canReinstatementItem,
    canReinstatement: canReinstatementItem
  }
}

export const comunicationsProceduresDetailMapper = (item: Procedure): ProcedureDetailModel => {
  return item && { ...item, detailDocuments: documentsMapper(item.documentsList) }
}

export const mapperCreateProcedure = (procedure: ProcedureModel): NewProcedure => {
  return {
    date: procedure.date,
    code: '',
    client: procedure.client,
    cups: procedure.cups,
    type: procedure.type,
    state: procedure.state,
    clientData: procedure.clientData
  }
}

export const mapperForCancellationAddProcedure = (procedure: ProcedureModel): NewProcedure => {
  return {
    date: procedure.date,
    code: '',
    client: procedure.client,
    clientData: procedure.clientData,
    cups: procedure.cups,
    type: procedure.type,
    state: procedure.state,
    parameters: parameterCancellationMapper(procedure)
  }
}

export const mapperForCancelProcedureGeneral = (
  procedure: ProcedureModel,
  type: AnnexedParameters,
  value: string
): NewProcedure => {
  return {
    date: procedure.date,
    code: '',
    client: procedure.client,
    clientData: procedure.clientData,
    cups: procedure.cups,
    type: procedure.type,
    state: procedure.state,
    parameters: parameterCancelProcedureGeneral(procedure, type, value)
  }
}

const documentsMapper = (
  documents: ProcedureDocument[] | undefined
): ProcedureDocumentModel[] | undefined => {
  return documents && documents.map(documentMapper)
}

const documentMapper = (document: ProcedureDocument): ProcedureDocumentModel => {
  return (
    document && {
      ...document,
      type: enumValueToKey(DocumentTypes, document.type),
      state: enumValueToKey(ProcedureStates, document.state),
      actions: generateIconsFromConfiguration(
        document,
        filterApplicableDocumentsActionsConfiguration(document, getGlobalActionsConfiguration()),
        new Map<ActionIcons, Function>([])
      ),
      annexed: parametersMapper(document.id, document.parameters)
    }
  )
}

export const documentMapperForCancellation = (procedure: Procedure): AddProcedureDocument => {
  let documentType: DocumentTypes | undefined

  switch (procedure.type) {
    case ProcedureTypes.CambioSINCambios_PWR:
    case ProcedureTypes.CambioCONCambios_PWR_Adm:
    case ProcedureTypes.CambioCONCambios_PWR_Tec:
    case ProcedureTypes.CambioCONCambios_PWR_Adm_y_Tec:
    case ProcedureTypes.Reclamacion_PWR_Tramitacion:
    case ProcedureTypes.Reclamacion_PWR_Factura:
    case ProcedureTypes.Reclamacion_PWR_CUPS:
    case ProcedureTypes.Reposicion:
      documentType = DocumentTypes.Paso_08
      break
    case ProcedureTypes.Alta_Nuevo_Suministro_PWR:
    case ProcedureTypes.Modificacion_PWR_Tec:
    case ProcedureTypes.Modificacion_PWR_Adm:
    case ProcedureTypes.Modificacion_PWR_Adm_y_Tec:
    case ProcedureTypes.Modificacion_Titular_PWR:
    case ProcedureTypes.Modificacion_Titular_y_Tec_PWR:
      documentType = DocumentTypes.Paso_06
      break
    case ProcedureTypes.Baja_Suministro_PWR:
      documentType = DocumentTypes.Paso_03
      break
  }

  return {
    idProcedure: procedure.id,
    type: documentType,
    date: moment().toDate(),
    state: ProcedureStates.Anulacion_solicitada,
    url: '.'
  }
}

const parametersMapper = (documentId: number, parameters: ProcedureParameter[]): JSX.Element => {
  return (
    <List key={documentId}>
      {parameters.map(parameter => (
        <ListItem key={parameter.idProcedure}>
          {enumTranslateOption(
            enumValueToKey(AnnexedParameters, parameter.type),
            AnnexedParameters,
            'enums:AnnexedParameters'
          )}
          : {parameter.value}
        </ListItem>
      ))}
    </List>
  )
}

const typesNotCancel: Array<ProcedureTypes> = [
  ProcedureTypes.ClienteSaliente,
  ProcedureTypes.ClienteSaliente_PWR,
  ProcedureTypes.Anulacion_Contratacion_GAS,
  ProcedureTypes.Baja_Suministro_GAS,
  ProcedureTypes.CorteSuministroGas,
  ProcedureTypes.ReengancheSuministroGas,
  ProcedureTypes.CorteSuministroPWR,
  ProcedureTypes.DesistimientoPasivo_PWR,
  ProcedureTypes.DesistimientoPasivo_GAS,
  ProcedureTypes.Reposicion_GAS,
  ProcedureTypes.ReposicionPasiva_GAS
]

const statesNotCancel: Array<ProcedureStates> = [
  ProcedureStates.Rechazado,
  ProcedureStates.Activo,
  ProcedureStates.Cerrado,
  ProcedureStates.Anulacion_solicitada,
  ProcedureStates.Anulado,
  ProcedureStates.Bloqueado
]

const typesPendingInformation: Array<ProcedureTypes> = [
  ProcedureTypes.Reclamacion_GAS_Tramitacion,
  ProcedureTypes.Reclamacion_GAS_Factura,
  ProcedureTypes.Reclamacion_GAS_CUPS,
  ProcedureTypes.Reclamacion_PWR_Tramitacion,
  ProcedureTypes.Reclamacion_PWR_Factura,
  ProcedureTypes.Reclamacion_PWR_CUPS
]

const typesReinstatement: Array<ProcedureTypes> = [
  ProcedureTypes.CambioSINCambios_PWR,
  ProcedureTypes.CambioCONCambios_PWR_Adm,
  ProcedureTypes.CambioCONCambios_PWR_Tec,
  ProcedureTypes.CambioCONCambios_PWR_Adm_y_Tec,
  ProcedureTypes.ClienteSaliente_PWR,

  ProcedureTypes.CambioSINCambios,
  ProcedureTypes.CambioCONCambios_Ampliacion_Caudal,
  ProcedureTypes.CambioCONCambios_Titular_y_Caudal,
  ProcedureTypes.CambioCONCambios_Titular,
  ProcedureTypes.ClienteSaliente
]

const statesCanChangeState: Array<ProcedureStates> = [
  ProcedureStates.Anulado,
  ProcedureStates.Descartado,
  ProcedureStates.Cerrado
]

const typesCanWithdraw: Array<ProcedureTypes> = [
  ProcedureTypes.CambioSINCambios, // 02 - Cambio de comercializador sin modificaciones
  ProcedureTypes.CambioSINCambios_PWR, // C1 - Cambio de comercializador sin modificaciones
  ProcedureTypes.CambioCONCambios_Titular, // 41_01 - Cambio de comercializador con modificaciones
  ProcedureTypes.CambioCONCambios_Ampliacion_Caudal, // 41_02 - Cambio de comercializador con modificaciones
  ProcedureTypes.CambioCONCambios_Titular_y_Caudal, // 41_03 - Cambio de comercializador con modificaciones
  ProcedureTypes.CambioCONCambios_PWR_Adm, // C2_S - Cambio de comercializador con modificaciones
  ProcedureTypes.CambioCONCambios_PWR_Tec, // C2_N - Cambio de comercializador con modificaciones
  ProcedureTypes.CambioCONCambios_PWR_Adm_y_Tec, // C2_A - Cambio de comercializador con modificaciones
  ProcedureTypes.Modificacion_PWR_Adm, // M1_S - Modificación en el contrato de acceso
  ProcedureTypes.Modificacion_PWR_Tec, // M1_N - Modificación en el contrato de acceso
  ProcedureTypes.Modificacion_PWR_Adm_y_Tec, // M1_A - Modificación en el contrato de acceso
  ProcedureTypes.Modificacion_GAS_Adm, // 05_02 - Modificación en el contrato de acceso
  ProcedureTypes.Modificacion_GAS_Tec, // 05_03 - Modificación en el contrato de acceso
  ProcedureTypes.Alta_Nuevo_Suministro, // 38 - Alta de un punto de suministro
  ProcedureTypes.Alta_Nuevo_Suministro_PWR // A3 - Alta de un punto de suministro
]

const statesCannotWithdraw: Array<ProcedureStates> = [ProcedureStates.Rechazado]

export const canReconnect = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return (
    (type === ProcedureTypes.CorteSuministroGas &&
      (state === ProcedureStates.Iniciado ||
        state === ProcedureStates.Aceptado ||
        state === ProcedureStates.Activo ||
        state === ProcedureStates.PendienteInformacion ||
        state === ProcedureStates.Anulacion_Rechazada ||
        state === ProcedureStates.AnalisisRechazo)) ||
    (type === ProcedureTypes.CorteSuministroPWR &&
      (state === ProcedureStates.Iniciado ||
        state === ProcedureStates.Aceptado ||
        state === ProcedureStates.PendienteInformacion ||
        state === ProcedureStates.Anulacion_Rechazada ||
        state === ProcedureStates.AnalisisRechazo))
  )
}

export const canCancelBajaGas = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return (
    type === ProcedureTypes.Baja_Suministro_GAS &&
    (state === ProcedureStates.Iniciado ||
      state === ProcedureStates.Aceptado ||
      state === ProcedureStates.Activo ||
      state === ProcedureStates.PendienteInformacion ||
      state === ProcedureStates.Anulacion_Rechazada ||
      state === ProcedureStates.AnalisisRechazo ||
      state === ProcedureStates.Descartado)
  )
}

export const canCancel = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return !typesNotCancel.includes(type) && !statesNotCancel.includes(state)
}

export const canWithdraw = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return typesCanWithdraw.includes(type) && !statesCannotWithdraw.includes(state)
}

export const isPendingInformation = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return !typesPendingInformation.includes(type) && state === ProcedureStates.PendienteInformacion
}

export const isPendingInformationClaim = (
  type: ProcedureTypes,
  state: ProcedureStates
): boolean => {
  return typesPendingInformation.includes(type) && state === ProcedureStates.PendienteInformacion
}

export const canReinstatement = (type: ProcedureTypes, state: ProcedureStates): boolean => {
  return typesReinstatement.includes(type) && state === ProcedureStates.Activo
}

export const canChangeState = (
  type: ProcedureTypes,
  state: ProcedureStates,
  parameters?: ProcedureParameter[]
): boolean => {
  if (type === ProcedureTypes.Anulacion_Contratacion_GAS && state !== ProcedureStates.Iniciado) {
    return false
  }

  if (
    (type === ProcedureTypes.CorteSuministroPWR ||
      type === ProcedureTypes.Reposicion_GAS ||
      type === ProcedureTypes.ReposicionPasiva_GAS) &&
    state === ProcedureStates.Activo
  ) {
    return false
  }

  let isDesistimientoPasivo =
    type === ProcedureTypes.DesistimientoPasivo_GAS ||
    type === ProcedureTypes.DesistimientoPasivo_PWR

  if (
    isDesistimientoPasivo &&
    (state === ProcedureStates.Activo || state === ProcedureStates.Rechazado)
  ) {
    return false
  }

  // Cambio titular PWR por sugrogación en estado Aceptado es estado final
  if (parameters && parameters.length > 0 && state === ProcedureStates.Aceptado) {
    const subrogacion = parameters?.find(
      param =>
        enumKeyToValue(AnnexedParameters, param.type) ===
          AnnexedParameters.MOTIVO_MODIFICACION_PWR && param.value === 'S'
    )
    if (subrogacion) {
      return false
    }
  }

  return !statesCanChangeState.includes(state)
}

export const isPendingInformationReinstatement = (
  type: ProcedureTypes,
  state: ProcedureStates
): boolean => {
  return (
    (type === ProcedureTypes.ReposicionPasiva || type === ProcedureTypes.ReposicionPasiva_GAS) &&
    state === ProcedureStates.Iniciado
  )
}

function parameterCancellationMapper(procedure: ProcedureModel): ProcedureParameter[] | undefined {
  return [
    {
      idProcedure: procedure.id,
      type: AnnexedParameters.SOLICITUD_ANULADA,
      value: procedure.code
    }
  ]
}

function parameterCancelProcedureGeneral(
  procedure: ProcedureModel,
  type: AnnexedParameters,
  value: string
): ProcedureParameter[] | undefined {
  return [
    {
      idProcedure: procedure.id,
      type: type,
      value: value
    }
  ]
}

export const getFormatedUtcToLocalDate = (dateString: Date) => {
  let date = new Date(dateString)
  let utc = DateTime.utc(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  )
  return utc.toLocal().toFormat('dd/MM/yyyy HH:mm:ss')
}

export const getFormatedUtcDate = (dateString: Date) => {
  let date = new Date(dateString)
  let utc = DateTime.utc(
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  )
  return utc.toFormat('dd/MM/yyyy HH:mm:ss')
}
